import VisaImg from './ic-visa.svg';
import MasterCardImg from './ic-master.svg';
import AmexImg from './ic-amex.svg';
import DiscoverImg from './ic-disc.svg';
import VisaelectronImg from './ic-visa-ele.svg';
import MaestroImg from './ic-maes.svg';
import UnionpayImg from './ic-union-pay.svg';
import CartesBancairesImg from './ic-cb.svg';
import DinersImg from './ic-diners.svg';
import JCBImg from './ic-jcb.svg';
import Default from './ic-default.svg';
import TipImg from './tip.svg';

export { TipImg };
const Images = {
  VISA: VisaImg,
  MASTER_CARD: MasterCardImg,
  AMEX: AmexImg,
  VISAELECTRON: VisaelectronImg,
  MAESTRO: MaestroImg,
  UNIONPAY: UnionpayImg,
  DISCOVER: [ DiscoverImg, DinersImg ],
  JCB: JCBImg,
  CARTES_BANCAIRES: CartesBancairesImg, // This cardType is just for showing
  DEFAULT: Default, // as a default icon for saved card
};

export default Images;
